(() => {
  const valid = ['mujer','hombre','unisex'];
  const url = new URL(location.href);
  let gender = url.searchParams.get('g');
  try {
    if (!valid.includes(gender)) gender = localStorage.getItem('mxs_gender') || localStorage.getItem('mxr_g');
    if (valid.includes(gender)) {
      localStorage.setItem('mxs_gender',gender);
      localStorage.setItem('mxr_g',gender);
    }
  } catch (_) {}
  if (!valid.includes(gender)) gender = 'unisex';
  document.documentElement.dataset.mxUniverse = gender;
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.getAttribute('href').startsWith('#') || anchor.hasAttribute('download')) return;
    let target;
    try { target = new URL(anchor.href,location.origin); } catch (_) { return; }
    if (target.origin !== location.origin) return;
    if (!(target.pathname === '/' || target.pathname.startsWith('/products/') || target.pathname.startsWith('/collections/'))) return;
    let current = document.querySelector('.mxs')?.dataset.gender || gender;
    const explicitGender = target.searchParams.get('g');
    if (valid.includes(explicitGender)) current = explicitGender;
    if (target.pathname.includes('perfumes-man')) current = 'hombre';
    else if (target.pathname.includes('perfumes-woman')) current = 'mujer';
    else if (target.pathname.includes('perfumes-unisex')) current = 'unisex';
    target.searchParams.set('g',current);
    anchor.href = target.href;
  },true);
})();
